"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var encrypt_generator_1 = require("./encrypt-generator");
// This generator uses a worker thread to encrypt the nextChunk
// while yielding the current one.
function makeGetAsyncPacketIteratorOnWorkerThread(worker, progressCallback) {
    return function getAsyncPacketIteratorOnWorkerThread(_a) {
        var data = _a.data, frameSize = _a.frameSize, kek = _a.kek, chunkSize = _a.chunkSize;
        return __asyncGenerator(this, arguments, function getAsyncPacketIteratorOnWorkerThread_1() {
            var w, initWorker, askNextChunk, resolver, encryptedBytes, totalBytes, chunks, queueNextChunk, i, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        w = worker;
                        initWorker = function () {
                            w.postMessage({
                                action: 'init',
                                data: data,
                                frameSize: frameSize,
                                kek: kek,
                                chunkSize: chunkSize,
                            }, [data]);
                        };
                        askNextChunk = function () {
                            w.postMessage({ action: 'getChunk' });
                        };
                        w.onmessage = function (ev) {
                            resolver(ev.data);
                        };
                        encryptedBytes = 0;
                        totalBytes = data.byteLength;
                        chunks = [];
                        queueNextChunk = function () {
                            var chunkPromise = new Promise(function (resolve) {
                                resolver = function (data) {
                                    if (data !== null) {
                                        encryptedBytes += data.data.byteLength;
                                        progressCallback && progressCallback({ totalBytes: totalBytes, encryptedBytes: encryptedBytes });
                                        queueNextChunk();
                                    }
                                    resolve(data);
                                };
                            });
                            chunks.push(chunkPromise);
                            askNextChunk();
                        };
                        initWorker();
                        queueNextChunk();
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!1) return [3 /*break*/, 5];
                        return [4 /*yield*/, __await(chunks[i])];
                    case 2:
                        r = _a.sent();
                        if (r === null) {
                            return [3 /*break*/, 5];
                        }
                        return [4 /*yield*/, __await(r)];
                    case 3: return [4 /*yield*/, _a.sent()];
                    case 4:
                        _a.sent();
                        delete chunks[i];
                        i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
}
exports.makeGetAsyncPacketIteratorOnWorkerThread = makeGetAsyncPacketIteratorOnWorkerThread;
if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
    // Worker
    var iterator_1;
    onmessage = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, action, others, data, frameSize, kek, chunkSize, _b, value, done, key, iv, data;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = ev.data, action = _a.action, others = __rest(_a, ["action"]);
                    if (!(action === 'init')) return [3 /*break*/, 1];
                    data = others.data, frameSize = others.frameSize, kek = others.kek, chunkSize = others.chunkSize;
                    iterator_1 = encrypt_generator_1.getAsyncPacketIterator({ data: data, frameSize: frameSize, kek: kek, chunkSize: chunkSize });
                    return [3 /*break*/, 3];
                case 1:
                    if (!(action === 'getChunk')) return [3 /*break*/, 3];
                    return [4 /*yield*/, iterator_1.next()];
                case 2:
                    _b = _c.sent(), value = _b.value, done = _b.done;
                    if (done) {
                        postMessage(null);
                        self.close();
                    }
                    else {
                        key = value.key, iv = value.iv, data = value.data;
                        postMessage({ key: key, iv: iv, data: data }, [data.buffer]);
                    }
                    _c.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
else {
    // Main
}
//# sourceMappingURL=web-encrypt-worker.js.map